import React, { useEffect, useMemo, useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/logo.png";
import Button from "react-bootstrap/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import NavDropdown from "react-bootstrap/NavDropdown";
// import { ImBlog } from "react-icons/im";
import { FiChevronDown, FiGlobe, FiMoon, FiSun } from "react-icons/fi";
import { useTranslation } from "react-i18next";

// import { CgFileDocument } from "react-icons/cg";
import './Navbar.css';

function NavBar({ theme = "light", onToggleTheme }) {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const navigate = useNavigate(); // Create the navigate function
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const langCode = i18n.resolvedLanguage === "es" ? "ES" : "EN";
  const isSpanish = i18n.resolvedLanguage === "es";

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  useEffect(() => {
    scrollHandler();
    window.addEventListener("scroll", scrollHandler, { passive: true });
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

   // Function to handle button click for navigation
   const handleButtonClick = () => {
    navigate("/lab");
  };

  const active = useMemo(() => {
    const path = location.pathname;
    const involvedPrefixes = [
      "/programs/ambassadors",
      "/programs/syep-internship",
      "/programs/code-and-soil",
      "/programs/senior-citizens",
      "/programs/tech-pal",
      "/programs/partner-with-us",
      "/programs/volunteer-opportunities",
    ];
    const isInvolved = involvedPrefixes.some((prefix) => path.startsWith(prefix));

    return {
      home: path === "/",
      about: path.startsWith("/about"),
      programs: path.startsWith("/programs") && !isInvolved,
      services: path.startsWith("/services"),
      team: path.startsWith("/team"),
      contact: path.startsWith("/contact"),
      involved: isInvolved,
    };
  }, [location.pathname]);
  
  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="xxl"
      className={`cf-navbar${navColour ? " cf-navbar--scrolled" : ""}${isSpanish ? " cf-navbar--es" : ""}`}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="cf-navbar-brand d-flex" aria-label="Choicest Fruit home">
          <img src={logo} className="img-fluid logo" alt="brand" />
        </Navbar.Brand>

        <div className="cf-navbar-right">
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            className="cf-navbar-toggle"
            onClick={() => {
              updateExpanded(expand ? false : "expanded");
            }}
          >
            <span></span>
            <span></span>
            <span></span>
          </Navbar.Toggle>
        </div>

        <Navbar.Collapse id="responsive-navbar-nav" className="cf-navbar-collapse">
          <Nav className="ms-auto cf-navbar-nav" aria-label="Primary">
            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)} active={active.home}>
                {t("nav.home")}
              </Nav.Link>
            </Nav.Item>

            {/* About Dropdown */}
            <NavDropdown
              title={
                <span className="cf-dropdown-title">
                  {t("nav.about")} <FiChevronDown className="cf-dropdown-icon" aria-hidden="true" />
                </span>
              }
              id="about-nav-dropdown"
              menuVariant="light"
              active={active.about}
            >
              <NavDropdown.Item as={Link} to="/about/who-we-are" onClick={() => updateExpanded(false)}>
                {t("nav.whoWeAre")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/our-mission" onClick={() => updateExpanded(false)}>
                {t("nav.ourMission")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/our-story" onClick={() => updateExpanded(false)}>
                {t("nav.ourStory")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/impact" onClick={() => updateExpanded(false)}>
                {t("nav.impact")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/our-partners" onClick={() => updateExpanded(false)}>
                {t("nav.ourPartners")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/testimonials" onClick={() => updateExpanded(false)}>
                {t("nav.testimonials")}
              </NavDropdown.Item>
            </NavDropdown>
            {/* End About Dropdown */}



            <NavDropdown
              title={
                <span className="cf-dropdown-title">
                  {t("nav.programs")} <FiChevronDown className="cf-dropdown-icon" aria-hidden="true" />
                </span>
              }
              id="programs-nav-dropdown"
              menuVariant="light"
              active={active.programs}
            >  
              <NavDropdown.Item as={Link} to="/programs/" onClick={() => updateExpanded(false)}>
              {t("nav.careerTrainingPrograms")}
              </NavDropdown.Item>                       
              <NavDropdown.Item as={Link} to="/programs/" onClick={() => updateExpanded(false)}>
              {t("nav.communityPrograms")}
              </NavDropdown.Item>               
              <NavDropdown.Item as={Link} to="/programs/" onClick={() => updateExpanded(false)}>
              {t("nav.workshopsExploratoryLearning")}
              </NavDropdown.Item>
           
            </NavDropdown>

            {/* Services Dropdown */}
            <NavDropdown
              title={
                <span className="cf-dropdown-title">
                  {t("nav.services")} <FiChevronDown className="cf-dropdown-icon" aria-hidden="true" />
                </span>
              }
              id="services-nav-dropdown"
              menuVariant="light"
              active={active.services}
            >
              <NavDropdown.Item as={Link} to="/services/favrhood" onClick={() => updateExpanded(false)}>
                {t("nav.favrhood")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/services/consulting-advisory" onClick={() => updateExpanded(false)}>
                {t("nav.consultingAdvisory")}
              </NavDropdown.Item>                                      
            </NavDropdown>
            {/* End Services Dropdown */}

              <NavDropdown
              title={
                <span className="cf-dropdown-title">
                  {t("nav.getInvolved")} <FiChevronDown className="cf-dropdown-icon" aria-hidden="true" />
                </span>
              }
              id="get-involved-nav-dropdown"
              menuVariant="light"
              active={active.involved}
            >
              <NavDropdown.Item as={Link} to="/programs/ambassadors" onClick={() => updateExpanded(false)}>
                {t("nav.ambassadors")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/programs/syep-internship" onClick={() => updateExpanded(false)}>
                {t("nav.internship")}
              </NavDropdown.Item>  
              <NavDropdown.Item as={Link} to="/programs/code-and-soil" onClick={() => updateExpanded(false)}>
                {t("nav.codeAndSoil")}
              </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/programs/senior-citizens" onClick={() => updateExpanded(false)}>
                {t("nav.seniorTech")}
              </NavDropdown.Item>
                 <NavDropdown.Item as={Link} to="/programs/tech-pal" onClick={() => updateExpanded(false)}>
                {t("nav.techPal")}
              </NavDropdown.Item>   
              <NavDropdown.Item as={Link} to="/programs/partner-with-us" onClick={() => updateExpanded(false)}>
                {t("nav.partnerWithUs")}
              </NavDropdown.Item>                   
              <NavDropdown.Item as={Link} to="/programs/volunteer-opportunities" onClick={() => updateExpanded(false)}>
                {t("nav.volunteerOpportunities")}
              </NavDropdown.Item>
            
            </NavDropdown>


            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/team"
                onClick={() => updateExpanded(false)}
                active={active.team}
              >
                {t("nav.team")}
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/contact"
                onClick={() => updateExpanded(false)}
                active={active.contact}
              >
                 {t("nav.contact")}
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                href="https://choicestfruit.com/blog/"
                target="_blank"
                rel="noreferrer"
              >
                 {t("nav.blogs")}
              </Nav.Link>
            </Nav.Item>

            <Nav.Item className="cf-navbar-lab-tools">
              <div className="fork-btn cf-navbar-cta">
                <Button
                  onClick={() => {
                    updateExpanded(false);
                    handleButtonClick();
                  }}
                  className="fork-btn-inner"
                  type="button"
                >
                  {t("nav.cfLab")}
                </Button>
              </div>

              <div className="cf-navbar-utils-vertical" aria-label="Utilities">
                <div className="cf-theme-toggle">
                  <Button
                    type="button"
                    onClick={() => onToggleTheme && onToggleTheme()}
                    className="cf-theme-toggle-btn"
                    aria-label={theme === "dark" ? t("common.switchToLight") : t("common.switchToDark")}
                    title={theme === "dark" ? t("common.switchToLight") : t("common.switchToDark")}
                  >
                    {theme === "dark" ? (
                      <FiSun className="cf-theme-toggle-icon" aria-hidden="true" />
                    ) : (
                      <FiMoon className="cf-theme-toggle-icon" aria-hidden="true" />
                    )}
                    <span className="cf-theme-toggle-label">{theme === "dark" ? t("common.light") : t("common.dark")}</span>
                  </Button>
                </div>

                <div className="cf-lang-toggle">
                  <NavDropdown
                    title={
                      <span className="cf-dropdown-title" aria-label={t("common.language")} title={t("common.language")}>
                        <FiGlobe className="cf-dropdown-icon" aria-hidden="true" />
                        <span className="cf-lang-code">{langCode}</span>
                        <FiChevronDown className="cf-dropdown-icon" aria-hidden="true" />
                      </span>
                    }
                    id="language-nav-dropdown"
                    menuVariant="light"
                    align="end"
                  >
                    <NavDropdown.Item
                      onClick={() => {
                        i18n.changeLanguage("en");
                        updateExpanded(false);
                      }}
                      active={i18n.resolvedLanguage === "en"}
                    >
                      {t("common.english")}
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      onClick={() => {
                        i18n.changeLanguage("es");
                        updateExpanded(false);
                      }}
                      active={i18n.resolvedLanguage === "es"}
                    >
                      {t("common.spanish")}
                    </NavDropdown.Item>
                  </NavDropdown>
                </div>
              </div>
            </Nav.Item>

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
